import clsx from "clsx";
import { IconProps } from "../../types/icons";
import { createColorClasses } from "@/theme/colors";

export const Spid = ({
  width = 24,
  height = 24,
  className,
  color,
  decorative = false,
  ariaLabel = "SPID",
}: IconProps) => {
  const classes = createColorClasses({ color });

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden={decorative}
      aria-label={!decorative ? ariaLabel : undefined}
      className={clsx(className, classes)}
    >
      <path
        d="M11.9996 0C5.38314 0 0 5.38343 0 11.9998C0 18.6166 5.38314 24 11.9996 24C18.6165 24 24 18.6166 24 11.9998C24 5.38343 18.6165 0 11.9996 0Z"
        fill="white"
      />
      <path
        d="M9.13824 11.8425C8.37925 11.0725 8 10.1162 8 8.97684C8 7.83516 8.37925 6.88577 9.13349 6.13004C9.88724 5.37661 10.8482 4.99805 12.0283 4.99805C13.2036 4.99805 14.1603 5.38168 14.895 6.15908C15.6312 6.93603 16 7.88727 16 9.02663C16 10.1628 15.6312 11.1066 14.895 11.8642C14.1603 12.619 13.2093 12.998 12.0378 12.998C10.8663 12.998 9.90008 12.6135 9.13824 11.8425Z"
        fill="#0066CC"
        stroke="#0066CC"
        strokeWidth="0.3"
      />
      <path
        d="M8 18.998C8 17.8501 8.37553 16.8963 9.11906 16.1395C9.86871 15.379 10.8207 14.998 11.9929 14.998C13.1553 14.998 14.1045 15.3836 14.8273 16.1641C15.5562 16.9459 16 17.8538 16 18.998H8Z"
        fill="#0066CC"
        stroke="#0066CC"
        strokeWidth="0.3"
      />
    </svg>
  );
};


